import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-status-bar',
    templateUrl: './status-bar.component.html',
    styleUrls: ['./status-bar.component.css']
})
export class StatusBarComponent implements OnInit {
    // é»è®¤ç¶ææ¡éç½®
    @Input() custom = {
        'radius': '2px',
        'txt': ['ä¸çº¿', 'å¼å¸¸', 'æ­£å¸¸', 'è­¦å'],
        'bgColor': ['#bcbcbc', '#E81E1E', '#339966', '#edc601'],
        'fontColor': ['#fffff', '#fffff', '#fffff', '#fffff'],
        'value': [0, 1, 2, 3],
    };
    @Input() statusValue: any;

    public index;

    // è·åç´¢å¼
    public indexValue(arr, value) {
        let i = 0;
        for (let item in arr) {
            if (arr[item] === value) {
                return i;
            }
            i++;
        }
    }

    constructor() {
    }

    ngOnInit() {
        let self = this;

    }

    ngOnChanges() {
        let self = this;
        self.index = self.indexValue(self.custom.value, self.statusValue);
    }

}
